import React from 'react'
import FileDownloadIcon from 'components/material-symbol/icons/FileDownload'

const MessagingDownloadIcon = ({ className }) => (
  <FileDownloadIcon
    className={className}
    data-testid="download"
    fontSize={24}
    htmlColor="#172024"
  />
)

export default MessagingDownloadIcon
